module.exports = __webpack_public_path__ + "img/circle_check_black.da523930.svg";